import { SituacaoProblema } from 'graphql/types.generated'
import { Problema } from 'view/atendimentos/detail/soap/aside/types/ProblemaModel'
import { CIAP_W78_CODIGO, TipoPreNatal } from 'view/atendimentos/detail/soap/pre-natal/model-preNatal'
import {
  isCiapGravidezAltoRisco,
  isCiapOuCidDeEncerramentoGestacao,
  isCiapOuCidDeGestacao,
  isCiapOuCidDePuerperio,
  isCidGravidezAltoRisco,
  isInicioOuContinuacaoPreNatal,
} from 'view/atendimentos/detail/soap/pre-natal/util-preNatal'

import { ProblemaCondicaoModel } from '../model-problemasCondicoes'
import * as verifications from './verifications-preNatal'
import { isAutomatico, isEvolucao } from './verifications-problemasCondicoes'

export function isCiapW78(codigoCiap: string) {
  return codigoCiap === CIAP_W78_CODIGO
}

export function isProblemaCondicaoDePreNatal(
  problemaCondicao: ProblemaCondicaoModel,
  hasProblemaComCiapW78AtivoPersistido: boolean
) {
  if (problemaCondicao && problemaCondicao.situacaoProblema !== SituacaoProblema.RESOLVIDO) {
    if (isEvolucao(problemaCondicao) && isProblemaCondicaoGravidezAltoRisco(problemaCondicao)) {
      return hasProblemaComCiapW78AtivoPersistido
    } else {
      return isProblemaCondicaoDeGestacao(problemaCondicao)
    }
  }

  return false
}

export function hasProblemaCondicaoDePreNatal(
  problemasCondicoes: ProblemaCondicaoModel[],
  hasProblemaComCiapW78AtivoPersistido: boolean
) {
  return problemasCondicoes?.some((problemaCondicao) =>
    isProblemaCondicaoDePreNatal(problemaCondicao, hasProblemaComCiapW78AtivoPersistido)
  )
}

export function isProblemaCondicaoDeGestacao(problemaCondicao: ProblemaCondicaoModel) {
  return isCiapOuCidDeGestacao(problemaCondicao?.ciap?.codigo, problemaCondicao?.cid?.codigo)
}

export const isProblemaCondicaoEvolucaoGravidezAltoRisco = (problemaCondicao?: ProblemaCondicaoModel) =>
  isProblemaCondicaoGravidezAltoRisco(problemaCondicao) && isEvolucao(problemaCondicao)

export function hasProblemaCondicaoEvolucaoGravidezAltoRisco(problemasCondicoes?: ProblemaCondicaoModel[]) {
  return problemasCondicoes?.some(isProblemaCondicaoEvolucaoGravidezAltoRisco)
}

export function hasProblemaCondicaoDeGestacao(problemasCondicoes?: ProblemaCondicaoModel[]) {
  return problemasCondicoes?.some(isProblemaCondicaoDeGestacao)
}

export function isProblemaCondicaoComCiapW78(problemaCondicao: ProblemaCondicaoModel) {
  return problemaCondicao && isCiapW78(problemaCondicao.ciap?.codigo)
}

export function isProblemaCondicaoComCiapW78Ativo(problemaCondicao?: ProblemaCondicaoModel) {
  return (
    problemaCondicao &&
    isProblemaCondicaoComCiapW78(problemaCondicao) &&
    problemaCondicao.situacaoProblema === SituacaoProblema.ATIVO
  )
}

export function isProblemaCondicaoComCiapW78Automatico(problemaCondicao: ProblemaCondicaoModel) {
  return verifications.isProblemaCondicaoComCiapW78(problemaCondicao) && isAutomatico(problemaCondicao)
}

export function hasProblemaCondicaoComCiapW78Ativo(problemasCondicoes?: ProblemaCondicaoModel[]) {
  return problemasCondicoes?.some(isProblemaCondicaoComCiapW78Ativo)
}

export function isProblemaCondicaoComCiapW78Resolvido(problemaCondicao?: ProblemaCondicaoModel) {
  return (
    problemaCondicao &&
    isProblemaCondicaoComCiapW78(problemaCondicao) &&
    problemaCondicao.situacaoProblema === SituacaoProblema.RESOLVIDO
  )
}

export function hasProblemaCondicaoComCiapW78(problemasCondicoes?: ProblemaCondicaoModel[]) {
  return problemasCondicoes?.some(isProblemaCondicaoComCiapW78)
}

export function hasProblemaCondicaoComCiapW78Automatico(problemasCondicoes?: ProblemaCondicaoModel[]) {
  return problemasCondicoes?.some(verifications.isProblemaCondicaoComCiapW78Automatico)
}

export function hasProblemaCondicaoComCiapW78Resolvido(problemasCondicoes?: ProblemaCondicaoModel[]) {
  return problemasCondicoes?.some(isProblemaCondicaoComCiapW78Resolvido)
}

export const isProblemaComCiapW78Ativo = (problemaCidadao?: Problema) =>
  isProblemaComCiapW78(problemaCidadao) && problemaCidadao.situacao === SituacaoProblema.ATIVO

export const hasProblemaComCiapW78Ativo = (problemasCidadao?: Problema[]) =>
  problemasCidadao?.some(isProblemaComCiapW78Ativo)

export const isProblemaComCiapW78 = (problemaCidadao?: Problema) =>
  problemaCidadao && isCiapW78(problemaCidadao.ciap?.codigo)

export function hasW78ExistenteDuplicado(listaProblema: Problema[]) {
  return (listaProblema ?? []).filter((problema) => isProblemaComCiapW78Ativo(problema)).length > 1
}

export const hasProblemaNaoEvolucaoPuerperio = (problemasCondicoes?: ProblemaCondicaoModel[]): boolean =>
  problemasCondicoes?.some(
    (problemaCondicao) =>
      isCiapOuCidDePuerperio(problemaCondicao.ciap?.codigo, problemaCondicao.cid?.codigo) &&
      !isEvolucao(problemaCondicao)
  )

export const isProblemaCondicaoGravidezAltoRisco = (problemaCondicao?: ProblemaCondicaoModel) =>
  problemaCondicao &&
  (isCiapGravidezAltoRisco(problemaCondicao.ciap?.codigo) || isCidGravidezAltoRisco(problemaCondicao.cid?.codigo))

export const hasProblemaCondicaoNaoEvolucaoGravidezAltoRisco = (problemasCondicoes?: ProblemaCondicaoModel[]) =>
  problemasCondicoes?.some(
    (problemaCondicao) => isProblemaCondicaoGravidezAltoRisco(problemaCondicao) && !isEvolucao(problemaCondicao)
  )

export const hasProblemaCondicaoGravidezAltoRisco = (problemasCondicoes?: ProblemaCondicaoModel[]) =>
  problemasCondicoes?.some(isProblemaCondicaoGravidezAltoRisco)

export const isProblemaCondicaoGravidezAltoRiscoAtivoOuLatente = (problemaCondicao?: ProblemaCondicaoModel) =>
  problemaCondicao &&
  verifications.isProblemaCondicaoGravidezAltoRisco(problemaCondicao) &&
  problemaCondicao.situacaoProblema !== SituacaoProblema.RESOLVIDO

export const hasProblemaCondicaoGravidezAltoRiscoAtivoOuLatente = (problemasCondicoes?: ProblemaCondicaoModel[]) =>
  problemasCondicoes?.some(isProblemaCondicaoGravidezAltoRiscoAtivoOuLatente)

export const isProblemaCondicaoEncerraGestacao = (problemaCondicao?: ProblemaCondicaoModel) =>
  problemaCondicao && isCiapOuCidDeEncerramentoGestacao(problemaCondicao?.ciap?.codigo, problemaCondicao?.cid?.codigo)

export const isProblemaNaoEvolucaoEncerraGestacao = (problemaCondicao?: ProblemaCondicaoModel) =>
  isProblemaCondicaoEncerraGestacao(problemaCondicao) && !isEvolucao(problemaCondicao)

export const isProblemaCondicaoDeGestacaoOrEncerraGestacao = (problemaCondicao?: ProblemaCondicaoModel) =>
  verifications.isProblemaCondicaoDeGestacao(problemaCondicao) ||
  verifications.isProblemaCondicaoEncerraGestacao(problemaCondicao)

export const hasProblemaNaoEvolucaoEncerraGestacao = (problemasCondicoes?: ProblemaCondicaoModel[]): boolean =>
  problemasCondicoes?.some(isProblemaNaoEvolucaoEncerraGestacao)

const countProblemasCondicoesWithCondition = (
  condition: (problemaCondicao: ProblemaCondicaoModel, hasProblemaComCiapW78AtivoPersistido?: boolean) => boolean,
  problemasCondicoes: ProblemaCondicaoModel[],
  hasProblemaComCiapW78AtivoPersistido?: boolean
) =>
  problemasCondicoes.reduce(
    (totalProblemas: number, problemaCondicao: ProblemaCondicaoModel) =>
      condition(problemaCondicao, hasProblemaComCiapW78AtivoPersistido) ? ++totalProblemas : totalProblemas,
    0
  )

export const hasOnlyOneProblemaNaoEvolucaoEncerraGestacao = (problemasCondicoes: ProblemaCondicaoModel[]) =>
  countProblemasCondicoesWithCondition(isProblemaNaoEvolucaoEncerraGestacao, problemasCondicoes) === 1

export const hasOnlyOneProblemaCondicaoDePreNatal = (
  problemasCondicoes: ProblemaCondicaoModel[],
  hasProblemaComCiapW78AtivoPersistido: boolean
) =>
  countProblemasCondicoesWithCondition(
    isProblemaCondicaoDePreNatal,
    problemasCondicoes,
    hasProblemaComCiapW78AtivoPersistido
  ) === 1

export const isSituacaoProblemaResolvidoDesabilitadaPreNatal = (
  isCiapW78: boolean,
  isEvolucao: boolean,
  isEdicao?: boolean,
  isLPC?: boolean,
  tipoPreNatal?: TipoPreNatal
) => {
  const isCiapW78NaAvaliacao = isCiapW78 && !isLPC
  const isPrimeiroOuContinuacaoAtendimentoPreNatal = isInicioOuContinuacaoPreNatal(tipoPreNatal)
  const isCiapW78SendoCriadoNaAvaliacao = isCiapW78NaAvaliacao && !isEdicao && !isEvolucao
  const isCiapW78SendoEditadoNaAvaliacao = isCiapW78NaAvaliacao && isEdicao
  return (
    (isCiapW78SendoEditadoNaAvaliacao && isPrimeiroOuContinuacaoAtendimentoPreNatal) || isCiapW78SendoCriadoNaAvaliacao
  )
}

export function hasCondicaoAtivaGravidezDuplicada(
  isEdit: boolean,
  inputForm: ProblemaCondicaoModel,
  currentValues: ProblemaCondicaoModel[],
  problemasAtivosLatentesCidadao: Problema[]
): boolean {
  const currentValuesWithoutInput = isEdit
    ? currentValues.filter((value) => value._id !== inputForm._id)
    : currentValues
  return (
    isProblemaCondicaoComCiapW78Ativo(inputForm) &&
    (hasProblemaCondicaoComCiapW78Ativo(currentValuesWithoutInput) ||
      hasProblemaComCiapW78Ativo(problemasAtivosLatentesCidadao))
  )
}
